<template>
  <div>
    <AgreementWarning v-model="showAgreementWarning" :bins="agreementMissingBins" />
    <v-row>
      <v-col cols="4">
        <v-card class="mx-auto" elevation="4">
          <v-card-text>
            <v-row align="center">
              <v-col cols="1">
                <v-icon x-large color="primary">mdi-credit-card</v-icon>
              </v-col>
              <v-col cols="11">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{ stringValues.lastOrder[currentLanguage.language] }}:
                      {{ lastOrderSentDate.substr(0, 10) | toDate }}
                      {{ lastOrderSentDate.substr(11, 5) }}
                    </v-list-item-subtitle>
                    <v-list-item-title class="headline mb-1">{{
                      sumOrder | toCurrency
                    }}</v-list-item-title>
                    <v-list-item-subtitle
                      >{{yourPurhasesStr}}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="mx-auto" elevation="4">
          <v-card-text>
            <v-row align="center">
              <v-col cols="1">
                <v-icon color="primary" x-large>mdi-medical-bag</v-icon>
              </v-col>
              <v-col cols="11">
                <v-list-item three-line>
                  <v-list-item-content>
                    <!-- строка «N уникальных товаров» убрана 07.10.2026: дашборд читает витрину
                         день × пользователь × филиал, число разных SKU из неё не считается -->
                    <v-list-item-title class="headline mb-1"
                      >{{ sumQuantityGoods }}
                      {{ stringValues.items[currentLanguage.language] }} </v-list-item-title
                    >
                    <v-list-item-subtitle
                      >{{ stringValues.countPurchasedGood[currentLanguage.language] }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="mx-auto" elevation="4">
          <v-card-text>
            <v-row align="center">
              <v-col cols="1">
                <v-icon color="primary" x-large>mdi-monitor-eye</v-icon>
              </v-col>
              <v-col cols="11">
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >{{ stringValues.youSaved[currentLanguage.language] }}
                      {{
                        (sumPriceDiscount / sumOrder) | toPercentage(2)
                      }}</v-list-item-subtitle
                    >
                    <v-list-item-title class="headline mb-1">{{
                      sumPriceDiscount | toCurrency
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{ stringValues.commission[currentLanguage.language] }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
        <!-- Snackbar -->
    <v-snackbar 
     v-model="snackbar.show"
     :timeout="snackbar.timeout"
     :color="snackbar.color"
     >
       {{ snackbar.message }}
       <template v-slot:action="{ attrs }">
         <v-btn text 
           v-bind="attrs"
           @click="snackbar.show = false"
          >
           Закрыть
         </v-btn>
       </template>
     </v-snackbar>
    <v-row>
      <!-- <v-dialog v-model="showPopup" :max-width="600">
        <template v-if="showPopup">
          <v-card>
            <v-container>
            <v-card-title>📢 Уважаемые партнёры!</v-card-title>
            <v-card-text>
               <p>
                  С 1 октября продление подписки будет осуществляться по новым тарифам.
                </p>
                <p>
                  👉 До 30 сентября у вас есть возможность продлить доступ по текущей цене.
                </p>
                <p>
                  Рекомендуем не откладывать оплату, чтобы сохранить выгоду и обеспечить бесперебойную работу сервиса.
                </p>
                <p>
                  Спасибо за сотрудничество и доверие к PharmCenter!
                </p>
                <p>
                  С уважением,
                </p>
                <p>
                  команда PharmCenter
                </p>
  
                <v-responsive>
                  <iframe width="500" height="300"
                    src="https://www.youtube.com/embed/LzEYpfOavj0?si=pA6HlSRBilOjD5dT"
                    frameborder="0"
                    allowfullscreen
                  ></iframe>
                </v-responsive>
                <p>Если возникнут вопросы, мы всегда готовы помочь.</p>
                </v-card-text>
              </v-container>
            <v-card-actions>
              <v-btn color="primary" @click="closePopup">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog> -->
      <!-- <v-col cols="3"
        ><v-btn
          @click="GetOrdersGroupedBy()"
          :loading="loadingOrdersGroupedBy"
          block
        >
          Применить фильтр
          <template v-slot:loader>
            <span>Ведётся поиск...</span>
          </template>
        </v-btn></v-col
      > -->
      <v-col cols="2"
        ><v-radio-group
          v-model="groupByDateVariant"
          row
          @change="GetOrdersGroupedBy()"
        >
          <v-radio :label="stringValues.byDays[currentLanguage.language]" value="dayly"></v-radio>
          <v-radio :label="stringValues.byMonth[currentLanguage.language]" value="monthly"></v-radio> </v-radio-group
      ></v-col>
      <!-- Источник заказов для дашборда (витрина v2): по умолчанию НФЦ без КМП, отдельно КМП, все вместе -->
      <v-col cols="2" class="d-flex align-center">
        <v-btn-toggle v-model="purchaseSource" mandatory dense color="primary" @change="GetOrdersGroupedBy()">
          <v-btn small value="nfc">НФЦ</v-btn>
          <v-btn small value="kmp">КМП</v-btn>
          <v-btn small value="all">Все</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="3">
        <v-menu
          ref="menu.sentDateFrom"
          v-model="menu.sentDateFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="sentDateFromFormatted"
              :label="stringValues.dateBegin[currentLanguage.language]"
              persistent-hint
              prepend-icon="mdi-clock-time-eight-outline"
              v-bind="attrs"
              v-on="on"
              :hint="stringValues.choseDateDelivery[currentLanguage.language]"
              clearable
              @click:clear="sentDateFrom = null; GetOrdersGroupedBy()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="sentDateFrom"
            no-title
            @input="menu.sentDateFrom = false"
            @change="GetOrdersGroupedBy()"
          ></v-date-picker> </v-menu
      ></v-col>
      <v-col cols="3"
        ><v-menu
          ref="menu.sentDateTo"
          v-model="menu.sentDateTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="sentDateToFormatted"
              :label="stringValues.dateInclusive[currentLanguage.language]"
              persistent-hint
              prepend-icon="mdi-clock-time-eight-outline"
              v-bind="attrs"
              v-on="on"
              :hint="stringValues.choseDateDelivery[currentLanguage.language]"
              clearable
              @click:clear="sentDateTo = null; GetOrdersGroupedBy()"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="sentDateTo"
            no-title
            @input="menu.sentDateTo = false"
            @change="GetOrdersGroupedBy()"
          ></v-date-picker> </v-menu
      ></v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card class="mx-auto" elevation="4">
          <v-card-text>
            <line-chart :chart-data="lineData" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto" elevation="4">
          <v-card-text>
            <pie-chart :chart-data="pieData" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ZERO.kz -->
    <span id="_zero_75287" style="display: none;">
      <noscript>
        <a href="https://zero.kz/?s=75287" target="_blank">
          <img src="https://c.zero.kz/z.png?u=75287" width="88" height="31" alt="ZERO.kz" />
        </a>
      </noscript>
    </span>
    <!-- End ZERO.kz -->

    <regional-partner-banner />
  </div>
</template>
<script>
import axios from "axios";
import LineChart from "../../charts/LineChart";
import PieChart from "../../charts/PieChart";
import RegionalPartnerBanner from "../../components/partner/RegionalPartnerBanner.vue";
import AgreementWarning from "../../components/core/AgreementWarning.vue";

// дата «3 месяца назад» в формате v-date-picker (YYYY-MM-DD), по локальному времени
function defaultSentDateFrom() {
  const d = new Date();
  d.setMonth(d.getMonth() - 3);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export default {
  name: "ChartContainer",
  components: { LineChart, PieChart, RegionalPartnerBanner, AgreementWarning },
  computed: {
    stringValues: {
      get() {
        return this.$store.getters.STRING_VALUES;
      },
    },
    currentLanguage: {
      get() {
        this.GetOrdersGroupedBy();
        return this.$store.getters.CURRENT_LANG;
      },
    },
    yourPurhasesStr() {
      return this.stringValues.yourPurchases[this.currentLanguage.language]
    }
  },
  data: (vm) => ({
    loadingOrdersGroupedBy: false,
    // источник отмены текущего запроса дашборда: новый запрос или уход со страницы отменяют предыдущий
    ordersGroupedByCancelSource: null,
    lineData: {},
    pieData: {},
    sumOrder: 0,
    sumQuantityGoods: 0,
    lastOrderSentDate: "",
    sumPriceDiscount: 0,
    showPopup: false,
    // окно «договор отсутствует или истёк» — только аптекам, решает CompanyAgreement/MyStatus
    showAgreementWarning: false,
    agreementMissingBins: [],
    // по умолчанию дашборд показывает последние 3 месяца: статистика за всё время с 2021 года
    // у крупных сетей считается долго; очистка поля даты снимает фильтр и показывает весь период
    sentDateFrom: defaultSentDateFrom(),
    sentDateTo: null,
    sentDateFromFormatted: vm.$options.filters.toDate(defaultSentDateFrom()),
    sentDateToFormatted: vm.$options.filters.toDate(),
    menu: { sentDateFrom: false, sentDateTo: false },
    groupByDateVariant: "dayly",
    // nfc — заказы сайта (и перенесённая история старого ФЦ), kmp — заказы КМП, all — всё вместе
    purchaseSource: "nfc",
    feedbackMessage: '',
    snackbar: {
      show: false,     // Показывать или нет
      message: '',     // Текст уведомления
      color: '',       // Цвет уведомления
      timeout: 3000,   // Время отображения (мс)
      },
  }),

  methods: {
    cancelOrdersGroupedBy(reason) {
      if (this.ordersGroupedByCancelSource) {
        this.ordersGroupedByCancelSource.cancel(reason);
        this.ordersGroupedByCancelSource = null;
      }
    },
    async GetOrdersGroupedBy() {
      this.loadingOrdersGroupedBy = true;
      let SearchProperty = {
        SentDateFrom: `${this.sentDateFrom ?? ""}`,
        SentDateTo: `${this.sentDateTo ?? ""}`,
        GroupByDateVariant: this.groupByDateVariant,
        PurchaseSource: this.purchaseSource,
      };

      // предыдущий запрос (смена периода/группировки) уже не нужен — отменяем, чтобы не крутился на сервере
      this.cancelOrdersGroupedBy("superseded");
      this.ordersGroupedByCancelSource = axios.CancelToken.source();

      let OrdersSearch = {
        SearchProperty,
        cancelToken: this.ordersGroupedByCancelSource.token,
      };

      this.ResetData();

      this.$store
        .dispatch("ORDERS_GROUPED_BY", OrdersSearch)
        .then((data) => {
          this.lineData = {
            labels: [],
            datasets: [],
          };

          this.lineData.datasets.push({
            label: this.stringValues.purchase[this.currentLanguage.language],
            backgroundColor: this.GetRandomColor(),
            data: [],
          });

          data.ordersGroupBySentDate.forEach((order) => {
            this.lineData.labels.push(
              this.$options.filters.toDate(order.date.substr(0, 10))
            );

            this.lineData.datasets[0].data.push(order.sum.toFixed(2));
          });

          this.pieData = {
            labels: [],
            datasets: [
              {
                backgroundColor: [],
                data: [],
              },
            ],
          };
          var colors = this.GenerateColor(
            "#BBDEFB",
            "#0D47A1",
            data.ordersGroupByFilial.length
          );
          data.ordersGroupByFilial.forEach((order, index) => {
            this.pieData.labels.push(order.filial.name);
            this.pieData.datasets[0].backgroundColor.push("#" + colors[index]);
            this.pieData.datasets[0].data.push(order.sum.toFixed(2));
          });

          let userData = data.ordersGroupByUser[0];
          this.sumOrder = userData.sumOrder;
          this.sumQuantityGoods = userData.sumQuantityGoods;
          this.lastOrderSentDate = userData.lastOrderSentDate;
          this.sumPriceDiscount = userData.sumPriceDiscount;

          this.loadingOrdersGroupedBy = false;
        })
        .catch((error) => {
          // отменённый запрос (ушли со страницы или сменили период) — спиннер не трогаем, его снимет новый запрос
          if (axios.isCancel(error)) return;
          this.loadingOrdersGroupedBy = false;
        });
    },

    async submitFeedback() {
      if (!this.feedbackMessage || this.feedbackMessage.trim() === '') {
        this.showErrorAlert("Пожалуйста, заполните поле с пожеланиями.");
        return;
      }

      let payload = {
        message: this.feedbackMessage.trim()
      }

      this.$store
        .dispatch("CREATE_FEEDBACK", payload)
        .then(() => {
          this.showSuccessAlert("Спасибо за ваши пожелания! Мы их рассмотрим.");
          this.feedbackMessage = ""; // Сбросить поле ввода
          this.closePopup(); // Закрыть диалог
        })
        .catch((error) => {
          this.showErrorAlert("Произошла ошибка при отправке данных. Попробуйте позже.");
          window.console.error("Ошибка отправки:", error);
          this.closePopup();
        });
    },
    ResetData() {
      this.sumOrder = 0;
      this.sumQuantityGoods = 0;
      this.lastOrderSentDate = "";
      this.sumPriceDiscount = 0;

      this.lineData = {
        labels: [],
        datasets: [],
      };

      this.pieData = {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: [],
          },
        ],
      };
    },

    GetRandomColor() {
      var letters = "0123456789ABCDEF";
      var color =
        "#0D47A1" +
        letters[Math.floor(Math.random() * 16)] +
        letters[Math.floor(Math.random() * 16)];
      return color;
    },

    Hex(c) {
      var s = "0123456789abcdef";
      var i = parseInt(c);
      if (i == 0 || isNaN(c)) return "00";
      i = Math.round(Math.min(Math.max(0, i), 255));
      return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
    },

    ConvertToHex(rgb) {
      return this.Hex(rgb[0]) + this.Hex(rgb[1]) + this.Hex(rgb[2]);
    },

    Trim(s) {
      return s.charAt(0) == "#" ? s.substring(1, 7) : s;
    },

    ConvertToRGB(hex) {
      var color = [];
      color[0] = parseInt(this.Trim(hex).substring(0, 2), 16);
      color[1] = parseInt(this.Trim(hex).substring(2, 4), 16);
      color[2] = parseInt(this.Trim(hex).substring(4, 6), 16);
      return color;
    },

    GenerateColor(colorStart, colorEnd, colorCount) {
      // The beginning of your gradient
      var start = this.ConvertToRGB(colorStart);

      // The end of your gradient
      var end = this.ConvertToRGB(colorEnd);

      // The number of colors to compute
      var len = colorCount;

      //Alpha blending amount
      var alpha = 0.0;

      var data = [];

      for (let i = 0; i < len; i++) {
        var c = [];
        alpha += 1.0 / len;

        c[0] = start[0] * alpha + (1 - alpha) * end[0];
        c[1] = start[1] * alpha + (1 - alpha) * end[1];
        c[2] = start[2] * alpha + (1 - alpha) * end[2];

        data.push(this.ConvertToHex(c));
      }
      return data;
    },

    closePopup() {
      this.showPopup = false;
    },
    
     showSuccessAlert(message) {
      this.snackbar = {
        show: true,
        message: message,
        color: 'green',
      };
    },

    showErrorAlert(message) {
      this.snackbar = {
        show: true,
        message: message,
        color: 'red',
      };
    },
  },
  mounted() {
    setTimeout(() => {
      this.showPopup = true;
    }, 1000);

    // Создаём массив, если ещё нет
    window._zero_kz_ = window._zero_kz_ || [];
    window._zero_kz_.push(['id', 75287]);
    window._zero_kz_.push(['type', 1]);
    // window._zero_kz_.push(['url_watcher', 200]);

    // Добавляем внешний скрипт
    const script = document.createElement("script");
    script.src =
      (document.location.protocol === "http:" ? "http:" : "https:") +
      "//c.zero.kz/z.js";
    script.async = true;

    document.body.appendChild(script);
  },
  created() {
    this.GetOrdersGroupedBy();
    // предупреждение о договоре: при каждом заходе на Главную, без localStorage; ошибка запроса окно не показывает
    this.$store
      .dispatch("COMPANY_AGREEMENT_MY_STATUS")
      .then((status) => {
        this.agreementMissingBins = (status && status.missingBINs) || [];
        this.showAgreementWarning = !!(status && status.showWarning);
      })
      .catch(() => {});
  },

  beforeDestroy() {
    // пользователь ушёл с главной (например, сразу в «Потребность»): дашборд ему уже не нужен,
    // отмена обрывает запрос в браузере и через CancellationToken — SQL на бэке
    this.cancelOrdersGroupedBy("route-left");
  },

  watch: {
    sentDateFrom() {
      this.sentDateFromFormatted = this.$options.filters.toDate(
        this.sentDateFrom
      );
      this.yourPurhasesStr = this.stringValues.yourPurchases[this.currentLanguage.language];
    },
    sentDateTo() {
      this.sentDateToFormatted = this.$options.filters.toDate(this.sentDateTo);
      this.yourPurhasesStr = 'Ваши покупки за выбранный период'
      //
    },
  },
};
</script>
